import React from 'react';
import { Box, Typography, Skeleton } from '@mui/material';

interface StatisticsTabProps {
    icon: React.ReactNode;
    label: string;
    value: number | null;
    loading?: boolean;
    onClick?: () => void;
}

export const StatisticsTab: React.FC<StatisticsTabProps> = ({ icon, label, value, loading, onClick }) => {

    const handleClick = () => {
        if (onClick) {
            onClick();
        }
    };

    return (
        <Box
            onClick={handleClick}
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                p: 2.5,
                border: '1px solid',
                borderColor: '#9588e8',
                borderRadius: 2,
                cursor: onClick ? 'pointer' : 'default',
                backgroundColor: 'white',
                transition: 'all 0.2s ease',
                '&:hover': onClick ? {
                    backgroundColor: '#9588e8',
                    '& .tab-icon': {
                        color: 'white',
                    },
                    '& .tab-text': {
                        color: 'white',
                    },
                    '& .tab-value': {
                        color: 'white',
                    },
                } : {},
            }}
        >
            <Box className="tab-icon" sx={{ color: '#9588e8', display: 'flex', alignItems: 'center' }}>
                {icon}
            </Box>
            <Box sx={{ flex: 1 }}>
                <Typography className="tab-text" variant="body2" sx={{ color: '#9588e8', mb: 0.5 }}>
                    {label}
                </Typography>
                {loading ? (
                    <Skeleton variant="text" width={60} height={32} />
                ) : (
                    <Typography className="tab-value" variant="h4" sx={{ color: '#9588e8', fontWeight: 700 }}>
                        {value ?? 0}
                    </Typography>
                )}
            </Box>
        </Box>
    );
};

